export var HiddenUIElement = /*#__PURE__*/ function(HiddenUIElement) {
    HiddenUIElement[HiddenUIElement["Trade"] = 0] = "Trade";
    HiddenUIElement[HiddenUIElement["Dice"] = 1] = "Dice";
    HiddenUIElement[HiddenUIElement["TileProbabilityViews"] = 2] = "TileProbabilityViews";
    HiddenUIElement[HiddenUIElement["RoadActionButton"] = 3] = "RoadActionButton";
    HiddenUIElement[HiddenUIElement["SettlementActionButton"] = 4] = "SettlementActionButton";
    HiddenUIElement[HiddenUIElement["CityActionButton"] = 5] = "CityActionButton";
    HiddenUIElement[HiddenUIElement["BuyDevCardActionButton"] = 6] = "BuyDevCardActionButton";
    HiddenUIElement[HiddenUIElement["EndTurnActionButton"] = 7] = "EndTurnActionButton";
    HiddenUIElement[HiddenUIElement["Bank"] = 8] = "Bank";
    HiddenUIElement[HiddenUIElement["PlayerViewResourceCards"] = 9] = "PlayerViewResourceCards";
    HiddenUIElement[HiddenUIElement["HowToWinFloatingVP"] = 10] = "HowToWinFloatingVP";
    HiddenUIElement[HiddenUIElement["InformationButton"] = 11] = "InformationButton";
    return HiddenUIElement;
}({});
export var BeginnerModeLevel = /*#__PURE__*/ function(BeginnerModeLevel) {
    BeginnerModeLevel[BeginnerModeLevel["Level1"] = 0] = "Level1";
    BeginnerModeLevel[BeginnerModeLevel["Level2"] = 1] = "Level2";
    BeginnerModeLevel[BeginnerModeLevel["End"] = 2] = "End";
    return BeginnerModeLevel;
}({});
export var BeginnerModePlayer = /*#__PURE__*/ function(BeginnerModePlayer) {
    BeginnerModePlayer[BeginnerModePlayer["HumanPlayer"] = 0] = "HumanPlayer";
    BeginnerModePlayer[BeginnerModePlayer["BotPlayer"] = 1] = "BotPlayer";
    return BeginnerModePlayer;
}({});
